import './styles.css'

export const Collections = () => {
  return (
    <>
      <p></p>
      <h1> Welcome to the Collections Manager! </h1>
    </>
  )
}
